import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import { getData } from "../../../../services/library";

function EdicionHojaRuta(props) {
  const [editar, setEditar] = useState(props.editar);
  const [datosRow, setDatosRow] = useState(props.datosRow);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [sucursales, setSucursales] = useState(null);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [vehiculos, setVehiculos] = useState(null);
  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState("");
  const [disbtn, setDisbtn] = useState(false);
  const [diasSeleccionados, setDiasSeleccionados] = useState({
    lunes: false,
    martes: false,
    miercoles: false,
    jueves: false,
    viernes: false,
    sabado: false,
  });

  // Días de la semana con números
  const diasSemana = [
    { id: "lunes", label: "Lunes", numero: 1 },
    { id: "martes", label: "Martes", numero: 2 },
    { id: "miercoles", label: "Miércoles", numero: 3 },
    { id: "jueves", label: "Jueves", numero: 4 },
    { id: "viernes", label: "Viernes", numero: 5 },
    { id: "sabado", label: "Sábado", numero: 6 },
  ];

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const handleClose = () => {
    setEditar(!editar);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

  // Manejar cambio de días
  const handleDiasChange = (event) => {
    setDiasSeleccionados({
      ...diasSeleccionados,
      [event.target.name]: event.target.checked,
    });
  };

  // useEffect(() => {
  //   getData("/vehiculos", setVehiculos);
  //   getData(
  //     "/sucursales/xsucauth/" + localStorage.getItem("suc_auth").split(","),
  //     setSucursales
  //   );
  // }, []);

    useEffect(() => {
    getData(
      "/sucursales/xsucauth/" + localStorage.getItem("suc_auth").split(","),
      setSucursales
    );
  }, []);
  
  useEffect(() => {
    if (sucursalSeleccionada && sucursalSeleccionada.id) {
      // Limpiar vehículo seleccionado cuando cambia la sucursal
      setVehiculoSeleccionado("");
      // Cargar vehículos de la sucursal seleccionada
      getData("/vehiculos/sucursal/" + sucursalSeleccionada.id, setVehiculos);
    } else {
      // Si no hay sucursal seleccionada, limpiar la lista de vehículos
      setVehiculos(null);
      setVehiculoSeleccionado("");
    }
  }, [sucursalSeleccionada]);

  useEffect(() => {
    // Vehículo
    if (datosRow?.id_vehiculo && vehiculos) {
      const vehiculoEncontrado = vehiculos.find(
        (d) => d.id === datosRow.id_vehiculo
      );
      if (vehiculoEncontrado) {
        setVehiculoSeleccionado(vehiculoEncontrado);
      }
    }

    // Días - convertir el string "1, 2, 3, 4, 5, 6" a los estados de días
    if (datosRow?.dias) {
      const diasArray = datosRow.dias.split(",").map((d) => parseInt(d.trim()));
      const nuevosDias = {
        lunes: diasArray.includes(1),
        martes: diasArray.includes(2),
        miercoles: diasArray.includes(3),
        jueves: diasArray.includes(4),
        viernes: diasArray.includes(5),
        sabado: diasArray.includes(6),
      };
      setDiasSeleccionados(nuevosDias);
    }
  }, [vehiculos, datosRow]);

  useEffect(() => {
    if (datosRow?.id_sucursal && sucursales) {
      const sucursalEncontrada = sucursales.find(
        (s) => s.id === datosRow.id_sucursal
      );
      if (sucursalEncontrada) {
        setSucursalSeleccionada(sucursalEncontrada);
      }
    }
  }, [sucursales, datosRow]);

  const EditarHoja = async (e) => {
    e.preventDefault();
    setDisbtn(true);
    // Validar que se haya seleccionado al menos un día
    const diasSeleccionadosArray = diasSemana.filter(
      (dia) => diasSeleccionados[dia.id]
    );

    try {
      // 1. Obtener los días actuales de la base de datos PRIMERO
      const responseDiasActuales = await fetch(
        UrlApi + "/envasado_hoja_dias/hoja/" + datosRow.id
      );
      const diasActuales = await responseDiasActuales.json();

      const nuevosDiasNumeros = diasSeleccionadosArray.map((dia) => dia.numero);
      const diasActualesNumeros = diasActuales.map((dia) => dia.dia);

      const nuevosDiasSorted = [...nuevosDiasNumeros].sort();
      const actualesDiasSorted = [...diasActualesNumeros].sort();

      const mismosDias =
        nuevosDiasSorted.length === actualesDiasSorted.length &&
        nuevosDiasSorted.every(
          (dia, index) => dia === actualesDiasSorted[index]
        );

      const datosOriginales = props.datosRow;
      const cambiosEnDatos =
        datosRow.nombre !== datosOriginales.nombre ||
        datosRow.descripcion !== datosOriginales.descripcion ||
        vehiculoSeleccionado.id !== datosOriginales.id_vehiculo ||
        sucursalSeleccionada.id !== datosOriginales.id_sucursal;

      // Si no hay cambios en nada, mostrar mensaje y salir
      if (!cambiosEnDatos && mismosDias) {
        setOpenSnack(true);
        setColorMensaje("#F5B041");
        setMensaje("No se detectaron cambios para guardar");
        return;
      }

      // 3. Actualizar la hoja de ruta principal solo si hay cambios
      if (cambiosEnDatos) {
        const responseHoja = await fetch(
          UrlApi + "/envasado_hoja_ruta/" + datosRow.id,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              nombre: datosRow.nombre,
              descripcion: datosRow.descripcion,
              id_sucursal: sucursalSeleccionada.id,
              id_vehiculo: vehiculoSeleccionado.id,
              usuario: localStorage.getItem("user"),
            }),
          }
        );

        const resultadoHoja = await responseHoja.json();

        if (!responseHoja.ok) {
          throw new Error(
            resultadoHoja.message || "Error al editar la hoja de ruta"
          );
        }
      }

      // 4. Actualizar días solo si hay cambios en los días
      if (!mismosDias) {

        // Para cada día actual, verificar si sigue seleccionado
        const updatesDias = diasActuales.map(async (diaActual) => {
          const sigueSeleccionado = nuevosDiasNumeros.includes(diaActual.dia);

          if (!sigueSeleccionado) {
            // Desactivar día que ya no está seleccionado
            return fetch(UrlApi + "/envasado_hoja_dias/" + diaActual.id, {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                activo: 0,
              }),
            });
          }
          return Promise.resolve();
        });

        // Insertar nuevos días que no existían antes
        const nuevosDiasParaInsertar = nuevosDiasNumeros.filter(
          (diaNumero) => !diasActualesNumeros.includes(diaNumero)
        );

        const insertsDias = nuevosDiasParaInsertar.map(async (diaNumero) => {
          return fetch(UrlApi + "/envasado_hoja_dias", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id_hoja: datosRow.id,
              dia: diaNumero,
              activo: 1,
            }),
          });
        });

        // Esperar a que todas las operaciones de días terminen
        await Promise.all([...updatesDias, ...insertsDias]);
      }

      // Éxito
      setOpenSnack(true);
      setColorMensaje("#D4EFDF");
      setMensaje("La Hoja de Ruta se editó exitosamente!");
    } catch (err) {
      console.error("Error:", err.message);
      setOpenSnack(true);
      setColorMensaje("#FADBD8");
      setMensaje(err.message || "Error al editar la hoja de ruta");
    }
  };

  return (
    <>
      <Dialog
        fullWidth
        open={editar}
        onClose={() => handleClose()}
        maxWidth="md"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Editar hoja de ruta {props.datosRow.nombre}
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={EditarHoja}>
          <DialogContent>
            {/* <Box
              backgroundColor="#F4F6F6"
              px={2}
              py={2}
              border={0.5}
              borderColor={"#ABB2B9"}
              borderRadius={3}
            > */}
              <Grid container spacing={1}>
                <Grid item xs={4} py={1} mb={1}>
                  <TextField
                    label="Nombre"
                    name="nombre"
                    size="small"
                    placeholder="..."
                    inputProps={{
                      maxLength: 100,
                    }}
                    focused
                    required
                    fullWidth
                    value={datosRow.nombre}
                    onChange={almacenar}
                  />
                </Grid>
                <Grid item xs={8} py={1} mb={1}>
                  <TextField
                    label="Descripción"
                    name="descripcion"
                    size="small"
                    placeholder="..."
                    inputProps={{
                      maxLength: 100,
                    }}
                    focused
                    required
                    fullWidth
                    value={datosRow.descripcion}
                    onChange={almacenar}
                  />
                </Grid>
                <Grid item xs={6} py={1} mb={1}>
                  <Autocomplete
                    disabled={!sucursales}
                    required
                    disableClearable
                    id="id_sucursal"
                    style={style}
                    size="small"
                    noOptionsText={"Sucursal INEXISTENTE"}
                    options={sucursales || ""}
                    autoHighlight
                    getOptionLabel={(s) => s.id + "-" + s.nombre}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={sucursalSeleccionada || null}
                    defaultValue={sucursalSeleccionada || null}
                    onChange={(event, value) => {
                      setSucursalSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.id} - {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar sucursal..."
                        {...params}
                        label="Sucursal"
                        focused
                        required
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6} py={1} mb={1}>
                  <Autocomplete
                    disabled={!vehiculos}
                    required
                    disableClearable
                    id="id_vehiculo"
                    style={style}
                    size="small"
                    noOptionsText={"Vehículo INEXISTENTE"}
                    options={vehiculos || ""}
                    autoHighlight
                    getOptionLabel={(veh) =>
                      veh.nombre || veh.patente || veh.modelo || ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={vehiculoSeleccionado || null}
                    defaultValue={vehiculoSeleccionado || null}
                    onChange={(event, value) => {
                      setVehiculoSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre || option.patente || option.modelo}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar vehículo..."
                        {...params}
                        label="Vehículo"
                        focused
                        // required
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} py={1} mb={1}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    fontWeight="500"
                    color="text.secondary"
                    sx={{ mb: 1.5, textAlign: "center" }}
                  >
                    Días de la semana *
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    {diasSemana.map((dia) => (
                      <Box
                        key={dia.id}
                        onClick={() =>
                          handleDiasChange({
                            target: {
                              name: dia.id,
                              checked: !diasSeleccionados[dia.id],
                            },
                          })
                        }
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          px: 2,
                          py: 1,
                          border: 1.5,
                          borderColor: diasSeleccionados[dia.id]
                            ? "primary.main"
                            : "grey.300",
                          borderRadius: 2,
                          backgroundColor: "white",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            borderColor: "primary.main",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            border: 1.5,
                            borderColor: diasSeleccionados[dia.id]
                              ? "primary.main"
                              : "grey.400",
                            backgroundColor: diasSeleccionados[dia.id]
                              ? "primary.main"
                              : "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {diasSeleccionados[dia.id] && (
                            <Box
                              sx={{
                                color: "white",
                                fontSize: "12px",
                                fontWeight: "bold",
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          )}
                        </Box>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: "500",
                            color: diasSeleccionados[dia.id]
                              ? "primary.main"
                              : "text.primary",
                          }}
                        >
                          {dia.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                mt={1}
              >
                <Grid item>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={() => handleClose()}
                    style={{ backgroundColor: "#fff" }}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item>
                  <Button type="submit" color="success" variant="contained" disabled={disbtn}>
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            {/* </Box> */}
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default EdicionHojaRuta;
